<div class="tab-content">
	<div class="px-5 py-4">
		<form #SaveEnergyUtilizationSettings="ngForm" (ngSubmit)="saveSiteEnergyUtilizationSettings()" [validate-form]="'energy_utilization_settings'">
			<div class="tab-pane fade show active" id="energy_utilization">
				<div class="row mb-4">
					<label for="max_disconnect_days" class="col-4 font-weight-bold">{{'site_utilization_settings.max_disconnect_days' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="energyStepValues.max_disconnect_days"
							min="0"
							name="max_disconnect_days"
							[(ngModel)]="energySettings.max_disconnect_days"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.days" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="minimum_meter_daily_kwh_usage" class="col-4 font-weight-bold">{{'site_utilization_settings.minimum_meter_daily_kwh_usage' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="energyStepValues.minimum_meter_daily_kwh_usage"
							min="0"
							name="minimum_meter_daily_kwh_usage"
							[(ngModel)]="energySettings.minimum_meter_daily_kwh_usage"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.kWh" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="maximum_meter_daily_kw_demand" class="col-4 font-weight-bold">{{'site_utilization_settings.maximum_meter_daily_kw_demand' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="energyStepValues.maximum_meter_daily_kw_demand"
							min="0"
							name="maximum_meter_daily_kw_demand"
							[(ngModel)]="energySettings.maximum_meter_daily_kw_demand"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.kw" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="energy_cost" class="col-4 font-weight-bold">{{'site_utilization_settings.energy_cost' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="energyStepValues.energy_cost"
							min="0"
							name="energy_cost"
							[(ngModel)]="energySettings.energy_cost"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.cost_kWh" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="energy_demand_charge" class="col-4 font-weight-bold">{{'site_utilization_settings.energy_demand_charge' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="energyStepValues.energy_demand_charge"
							min="0"
							name="energy_demand_charge"
							[(ngModel)]="energySettings.energy_demand_charge"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.charge_kW" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label class="col-4 font-weight-bold">{{'site_utilization_settings.low_disconnect_range' | translate}}</label>
					<div class="col-8">
						<div class="d-flex align-items-center">
							<div class="range-group">
								<span class="range-label">Min:</span>
								<input class="form-control input-field range-input" 
									type="number"
									[step]="energyStepValues.low_disconnect_range_min"
									min="1"
									name="low_disconnect_range_min"
									[(ngModel)]="energySettings.low_disconnect_range_min"
									(input)="validateInputs()"
								>
							</div>
							<div class="range-group">
								<span class="range-label">Max:</span>
								<input class="form-control input-field range-input" 
									type="number"
									[step]="energyStepValues.low_disconnect_range_max"
									[min]="energySettings.low_disconnect_range_min + 1"
									name="low_disconnect_range_max"
									[(ngModel)]="energySettings.low_disconnect_range_max"
									(input)="validateInputs()"
								>
							</div>
							<span class="input-group-addon"><span>{{"g.days" | translate}}</span></span>
						</div>
					</div>
				</div>
				<div class="row mb-4">
					<label class="col-4 font-weight-bold">{{'site_utilization_settings.mid_disconnect_range' | translate}}</label>
					<div class="col-8">
						<div class="d-flex align-items-center">
							<div class="range-group">
								<span class="range-label">Min:</span>
								<input class="form-control input-field range-input" 
									type="number"
									[step]="energyStepValues.mid_disconnect_range_min"
									[min]="energySettings.low_disconnect_range_max + 1"
									name="mid_disconnect_range_min"
									[(ngModel)]="energySettings.mid_disconnect_range_min"
									(input)="validateInputs()"
								>
							</div>
							<div class="range-group">
								<span class="range-label">Max:</span>
								<input class="form-control input-field range-input" 
									type="number"
									[step]="energyStepValues.mid_disconnect_range_max"
									[min]="energySettings.mid_disconnect_range_min + 1"
									name="mid_disconnect_range_max"
									[(ngModel)]="energySettings.mid_disconnect_range_max"
									(input)="validateInputs()"
								>
							</div>
							<span class="input-group-addon"><span>{{"g.days" | translate}}</span></span>
						</div>
					</div>
				</div>
				<div class="row mb-4">
					<label for="high_disconnect_limit" class="col-4 font-weight-bold">{{'site_utilization_settings.high_disconnect_limit' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="energyStepValues.high_disconnect_limit"
							[min]="energySettings.mid_disconnect_range_max + 1"
							name="high_disconnect_limit"
							[(ngModel)]="energySettings.high_disconnect_limit"
							(input)="validateInputs()"

						>
						<span class="input-group-addon"><span>{{"g.days" | translate}}</span></span>
					</div>
				</div>
				<div class="row my-4 align-items-center">
					<div class="col-md-4">
					</div>
					<div class="col-md-8">
						<div class="row align-items-center">
							<div class="col-md-8">
								<button type="submit" [disabled]="disableButton" class="btn text-white main-blue-bg btn-lg col-5 mr-4">{{'g.save' | translate}}</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>